import { LINKS } from '@trip-ux/constants';
import axios from 'axios';
import { get } from 'lodash';
import { prepareHeaders } from '../api.client';
import { ReduxStore } from '../payload-types';
import { fork, select, call, take, put } from 'redux-saga/effects';
import { ORGANIZATION_SEARCH, ORGANIZATION_SEARCH_RESULT } from './types';
import { sortObject } from '../utils';

const getOrganizationList = (state: ReduxStore, payload) =>
  axios
    .get(`${get(state, 'config.options.contextPath', '')}${LINKS.DISTRIBUTION}`, {
      params: payload,
      headers: Object.fromEntries(Object.entries(prepareHeaders(state)).map(([k, v]) => [k, String(v)]))
    })
    .then(res => get(res, 'data', []))
    .catch(() => []);

function* watchOrganizationSearchRequest() {
  while (true) {
    const { payload } = yield take(ORGANIZATION_SEARCH);
    const state: ReduxStore = yield select((store: ReduxStore) => store);
    const organizations = yield call(getOrganizationList, state, payload);
    const sortedOrganizations = sortObject(organizations, state.config.locale);
    yield put({ type: ORGANIZATION_SEARCH_RESULT, payload: sortedOrganizations });
  }
}

export default [fork(watchOrganizationSearchRequest)];
